import React from 'react';
import './footer.css'
function Footer() {
  return <div className='footer'>Made with 💚</div>;
}

export default Footer;
